export default "__VITE_ASSET__CsWrlpcR__"